import AngleBg from "../entities/AngleBg";
import { Coord } from "../../../../../src/types/Interface";
import PointManager from "./PointManager";
import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";

export default class AngleBgManager {
  private PointManager = PointManager.getInstance();
  private cCoord: Coord;
  centerBg: AngleBg;
  circumBg: AngleBg;

  constructor(cCoord: Coord, radian: number) {
    this.cCoord = cCoord;
    const circlePoint = this.PointManager.circlePoint;
    const circumPoint = this.PointManager.getRedPoints()[2];
    this.circumBg = new AngleBg(this.cCoord, circumPoint, radian, 0x98d6ff);
    this.centerBg = new AngleBg(this.cCoord, circlePoint, radian, 0xffceeb);

    rootEventBus.on(EnumRootEventBus.cancelledCircleAnim, () => this.handleCancelCircleAnim())
  }
  
  handleCancelCircleAnim = () => setTimeout(() => [this.circumBg, this.centerBg].forEach(bg => bg.clear()), 0);
}
